import type { PortKeysInterface, ConnectionPointsInterface } from './types';
import {
  ADD_CONNECTION,
  REMOVE_CONNECTION,
  EDIT_CONNECTION,
  UPDATE_CONNECTION_POINTS,
  REMOVE_CONNECTIONS,
  SET_CONNECTION_COLOR,
} from './types';

export interface AddConnectionActionInterface {
  [extraProps: string]: unknown;
  type: typeof ADD_CONNECTION;
  payload: {
    portkeys: PortKeysInterface;
    key?: string;
    connectionPoints?: ConnectionPointsInterface[];
  };
}

export function addConnection(
  portkeys: PortKeysInterface,
  key?: string,
  connectionPoints?: ConnectionPointsInterface[],
): AddConnectionActionInterface {
  return {
    type: ADD_CONNECTION,
    payload: { portkeys, key, connectionPoints },
  };
}

export interface RemoveConnectionActionInterface {
  [extraProps: string]: unknown;
  type: typeof REMOVE_CONNECTION;
  payload: PortKeysInterface | PortKeysInterface[];
}

export function removeConnection(
  portKeys: PortKeysInterface | PortKeysInterface[],
): RemoveConnectionActionInterface {
  return {
    type: REMOVE_CONNECTION,
    payload: portKeys,
  };
}

export interface RemoveConnectionsActionInterface {
  [extraProps: string]: unknown;
  type: typeof REMOVE_CONNECTIONS;
  payload: string;
}

export function removeConnections(
  unitKey: string,
): RemoveConnectionsActionInterface {
  return {
    type: REMOVE_CONNECTIONS,
    payload: unitKey,
  };
}

export interface UpdateConnectionPointsPayloadInterface {
  connectionKey: string;
  updateConnectionPoints: ConnectionPointsInterface[];
}
export interface UpdateConnectionPointsAction {
  type: typeof UPDATE_CONNECTION_POINTS;
  payload: {
    updatedConnectionPointsPayload: UpdateConnectionPointsPayloadInterface;
  };
}

export function updateConnectionPoints(
  updatedConnectionPointsPayload: UpdateConnectionPointsPayloadInterface,
): UpdateConnectionPointsAction {
  return {
    type: UPDATE_CONNECTION_POINTS,
    payload: { updatedConnectionPointsPayload },
  };
}

export interface EditConnectionPayloadInterface {
  portMode: string; // FIX: This should proably be an enum
  fromPort: string;
  toPort: string;
  from: string;
  to: string;
  flowRatePosition: number;
}
export interface EditConnectionActionInterface {
  [extraProps: string]: unknown;
  type: typeof EDIT_CONNECTION;
  payload: EditConnectionPayloadInterface[];
}

export function editConnection(
  portKeys: EditConnectionPayloadInterface[],
): EditConnectionActionInterface {
  return {
    type: EDIT_CONNECTION,
    payload: portKeys,
  };
}

export interface SetConnectionColorActionInterface {
  [extraProps: string]: unknown;
  type: typeof SET_CONNECTION_COLOR;
  payload: {
    connectionKeys: string[];
    color?: string;
  };
}

export function setConnectionColor(
  connectionKeys: string | string[],
  color?: string,
): SetConnectionColorActionInterface {
  return {
    type: SET_CONNECTION_COLOR,
    payload: {
      connectionKeys: Array.isArray(connectionKeys)
        ? connectionKeys
        : [connectionKeys],
      color,
    },
  };
}
